export default {
  please: {
    en: 'Please',
  },
  login: {
    en: 'login',
  },
  or: {
    en: 'or',
  },
  register: {
    en: 'register',
  },
  text: {
    en: 'to write a review',
  },
  button: {
    en: 'Got it',
  },
}
